import { getHelplineNumber } from "@/Containers/DomainSalesSearch/utils/domain";

export const HOME_PAGE_USER_RESTRICTION_SEEN = "HOME_PAGE_USER_RESTRICTION_SEEN";

export const DS_HELPLINE_NUMBER = getHelplineNumber() || "07428533884";

export const DEFAULT_PER_PAGE_SIZE_OPTIONS = [50, 100, 150];
